import BtnGlemoImg from '../../../assets/btn-voice-glemo.svg'

export default function ModalSearching() {
  return (
    <>
        <>
          <div className="modal-form-busca modal-searching modal-form-busca-mobile justify-center fixed z-[1001] w-[100vw] h-[100vh] top-0 left-0">
            <div className="relative w-full h-full lg:py-5 justify-items-center">
              <div className="container-modal justify-between max-w-[441px] pb-10 h-full border-0 text-black relative flex flex-col bg-white lg:bg-transparent outline-none focus:outline-none p-4 overflow-y-auto w-full">
                <>
                  <div className="justify-items-center grid content-center h-full">
                    <div className="btn-third-layer-btn rounded-full p-12">
                      <div className="btn-first-layer-btn rounded-full p-10">
                        <div className="btn-sec-layer-btn rounded-full p-8">
                          <img width={73} height={73} className="max-w-full" src={BtnGlemoImg} />
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              </div>
            </div>
          </div>
          <div className="opacity-25 fixed inset-0 z-[1000] bg-black"></div>
        </>
    </>
  )
}
